import React, { useContext } from 'react';
import styled from 'styled-components';
import useGetIncompatibleBottle from 'hooks/useGetIncompatibleBottle';
import ui from 'config-app/ui';
import { appStore } from 'store/app';


const Component = ({ variants, products, selectedId, onClick }) => {

  const [appState] = useContext(appStore);
  const sizeId = appState.steps.find((v) => v.type === "bottleSize").id;

  return (
    <Container>
      <Options>
        <div className="inner">
          {variants.map((id, index) => {
            let outOfStock = false;
            let grayLine = false;
            let selectedItem = products[id].variants[sizeId];
            const inventoryPolicy = selectedItem.inventory_policy;
            const inventoryQuantity = selectedItem.inventory_quantity;
            if (inventoryQuantity <= 0 && inventoryPolicy === "deny") {
              outOfStock = true;
            }
            const code = products[id].color;
              const red   = parseInt(code.substring(1,3), 16);
              const green = parseInt(code.substring(3,5), 16);
              const blue  = parseInt(code.substring(5,7), 16);
            if (red >= 240 && green >=240 && blue >=240 ) {
              grayLine = true;
            }
            return (
              <ColorItem
                key={index}
                id={id}
                color={products[id].color}
                selected={selectedId === id}
                onClick={onClick}
                outOfStock={outOfStock}
                grayLine={grayLine}
              />
            );
          })}
        </div>
      </Options>
    </Container>
  );
};

const ColorItem = ({ outOfStock, grayLine, id, color, selected, onClick }) => {
  const disabled = useGetIncompatibleBottle(id, 'Bottle');
  if (!disabled) {
    return (
      <Item
        color={color}
        selected={selected}
        onClick={() => onClick(id)}
        disabled={outOfStock && "disabled"}
        className={grayLine && "gray"}
      >
        <div className="outer">
          <div className="colorchip"></div>
        </div>
      </Item>
    );
  } else {
    return null;
  }

};

export default Component;

const Container = styled.div`
  ${ui.MQ_MD_LG} {
    margin-top: 20px;
  }

  ${ui.MQ_XS_SM} {
    margin-left: -30px;
    margin-top: 14px;
  }
`;

const Options = styled.div`
  .inner {
    display: flex;
  }
  ${ui.MQ_MD_LG} {
    max-width: 510px;
    .inner {
      flex-wrap: wrap;
    }
  }
  ${ui.MQ_XS_SM} {
    overflow-x: auto;
    width: 100vw;
    .inner {
      flex-wrap: nowrap;
      gap: 0 4px;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const Item = styled.div`
  justify-content: center;
  position: relative;

  &[disabled] {
    .colorchip::after {
      position: absolute;
      content: '';
      background: #fff;
      width: 4px;
      transform: rotate(45deg);
      transform-origin: left top;
      right: 5px;
    }
  }
  
  &.gray[disabled] .colorchip::after {
    background: #B9B9B9;
  }
  &.gray .colorchip {
    border: 1px solid #d7d7d7;
  }

  .outer {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-sizing: border-box;
    border: 3px solid ${(props) => (props.selected ? '#333333' : 'tranparent')};
    opacity: 1;
    cursor: pointer;
  }

  .colorchip {
    border-radius: 50%;
    position: relative;
    box-sizing: content-box;
    background: ${(props) => props.color};
  }
  ${ui.MQ_MD_LG} {
    &[disabled] {
      .colorchip::after {
        height: 61px;
        top: 8px;
      }
    }
    &:not(:nth-child(7n)),
    &:not(:first-child) {
      margin-left: 5px;
    }
    &:nth-child(n+7) {
      margin-top: 5px;
    }
    .outer {
      width: 80px;
      height: 80px;
    }
    .colorchip {
      width: 60px;
      height: 60px;
    }
  }
  ${ui.MQ_XS_SM} {
    &[disabled] {
      .colorchip::after {
        height: 54px;
        top: 6px;
      }
    }
    &:first-child {
      margin-left: 30px;
    }
    .outer {
      width: 69px;
      height: 69px;
    }
    .colorchip {
      flex-shrink: 0;
      width: 53px;
      height: 53px;
    }
  }
`;